import React from "react";
import { Form, Row, Col, InputNumber, Divider } from "antd";

const CNCMetaForm = ({ prefix }) => {
  return (
    <>
      <Divider orientation="left">CNC</Divider>
      <Row gutter={25}>
        <Col md={12} xs={24}>
          <Form.Item
            label="Planned down time"
            name={[prefix, "planned_down_time"]}
          >
            <InputNumber
              addonAfter="minutes"
              placeholder="Planned down time"
              defaultValue={0}
              precision={0}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item
            label="Planned production count"
            name={[prefix, "planned_production"]}
            rules={[
              {
                required: true,
                message: "Please input Planned production count...!",
              },
            ]}
          >
            <InputNumber
              defaultValue={0}
              precision={0}
              placeholder="Planned Production Count"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item
            label="Cycle Time"
            name={[prefix, "cycle_time"]}
            rules={[
              {
                required: true,
                message: "Please input Cycle Time...!",
              },
            ]}
          >
            <InputNumber
              addonAfter="sec"
              defaultValue={0}
              placeholder="Cycle Time"
              precision={0}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item
            label="Machining Cycle"
            name={[prefix, "machining_cycle"]}
            rules={[
              {
                required: true,
                message: "Please input Machining Cycle...!",
              },
            ]}
          >
            <InputNumber
              defaultValue={0}
              placeholder="Machining Cycle"
              precision={0}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item
            label="Raw Weight"
            name={[prefix, "raw_weight"]}
          >
            <InputNumber
              addonAfter="gm"
              defaultValue={0}
              precision={0}
              placeholder="Raw weight"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item
            label="Finished Weight"
            name={[prefix, "finished_weight"]}
          >
            <InputNumber
              addonAfter="gm"
              defaultValue={0}
              precision={0}
              placeholder="Finished weight"
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
        <Col md={12} xs={24}>
          <Form.Item
            label="Wages per hour"
            name={[prefix, "wages_per_hour"]}
            rules={[
              {
                required: true,
                message: "Please input Wages per hour...!",
              },
            ]}
          >
            <InputNumber
              addonBefore="₹"
              addonAfter=""
              precision={undefined}
              defaultValue={0}
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default CNCMetaForm;
